import React, { Component, useState, useEffect } from 'react';
import Checkbox from '../Checkbox';
import QuantitySelector from '../QuantitySelector';
import ConfiguratorOptionPrice from '../ConfiguratorOptionPrice';
import ProductPrice from '../ProductPrice';
import YourSelections from '../YourSelections';
import { translate } from '../../Services/translation';
import { culture } from '../../Services/culture';
import { currency } from '../../Services/currency';
import { useDispatch } from 'react-redux';
import { selectSuperBuilderVariant, setSectionsSelected } from '../../Actions/SuperBuilder.action';

const SuperBuilder = (props) => {
        const dispatch = useDispatch();
        const maximumNumberOfItemsInCollection = 50;
        const maximumNumberOfItemsInSection = 8;
        const formatter = new Intl.NumberFormat(culture, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });

        const [data, setdata] = useState([]);
        const [sectionsSelected, setsectionsSelected] = useState(false);
        const [totalsData, settotalsData] = useState([]);
        const [selectedVariants, setselectedVariants] = useState([]);
        const [yourSelectionActive, setyourSelectionActive] = useState(false);
        const [selectOptions, setselectOptions] = useState([]);
        const [prices, setprices] = useState([]);
        const [totals, settotals] = useState();
        const [grandTotal, setgrandTotal] = useState(0);
        const [superBuilderTotal, setsuperBuilderTotal] = useState(0);
        const [originalTotal, setoriginalTotal] = useState(0);
        const [configuratorTotal, setconfiguratorTotal] = useState(0);
        const [originalPrice, setoriginalPrice] = useState(0);
        const [showMoreButton, setshowMoreButton] = useState(false);
        const [firstIteration, setfirstIteration] = useState(true);
        const [anySelectionMade, setanySelectionMade] = useState(false);
        const [refreshSections, setrefreshSections] = useState(false);
        const [quantity, setquantity] = useState(0);
                                     
    

    useEffect(() => {
        if (props) {
            setquantity(props.quantity);
            var superBuilderData = JSON.parse(props.superBuilder);
            var pricesData = JSON.parse(props.prices);            
    
            setdata(superBuilderData);
            setprices(pricesData);
            setselectOptions(props.selectOptions);
            setsectionsSelected(false);
            
        }        
    }, []);

    useEffect(() => {
        if (data && data.sections) {
            refreshPrice(data, quantity);
            let totals = getGrandTotal();
            setgrandTotal(totals.grandTotal);
            setoriginalTotal(totals.originalTotal);
            setsuperBuilderTotal(totals.configTotal);
            setshowMoreButton(data.sections.length > 1);
            setoriginalPrice((totals.originalTotal / (props.packagingQuantity > 0 ? props.packagingQuantity : 1)));
            
                let any = false;
                data.sections.forEach(s => s.variants.forEach((v) => {
                    if (v.selected) {
                        any = true;
                    }
                }));
                setanySelectionMade(any);  
                if (any) {
                    setyourSelectionActive(true);
                } else {
                    setyourSelectionActive(false);
                }
        }        
    }, [data, data.sections]);

    const getTotalPriceFromKeys = (keys, totalPrice) => {
        let totalPrices = {
            price: 0,
            originalPrice: 0,
            grandTotal: 0
        };

        var amountOfPricesToAdd = keys.length;
        var index = 0;
        for (let i = 0; i < prices.length; i++) {
            let price = prices[i],
                test = { key: "", value: [], added: false, quantity: 0 },
                priceNotMatched = true;

            for (let y = 0; y < keys.length; y++) {
                priceNotMatched = true;
                if (!keys[y].added) {
                    priceNotMatched = true;
                    for (let u = 0; u < keys[y].value.length; u++) {
                        //priceNotMatched = !price.systemKeys.includes(keys[y].value[u]);

                        priceNotMatched = !(price.systemKeys.includes(keys[y].key) && price.systemKeys.includes(keys[y].value[u]));
                        if (priceNotMatched) {
                            break;
                        }
                    }

                    if (priceNotMatched && keys[y].value.length === 0) {                        
                        test = keys[y];                        
                        test.value = test.key;
                        break;
                    }

                    if (!priceNotMatched) {
                        test = keys[y];
                        break;
                    }
                }
            }

            if (!test.added && test.value.length > 0 && amountOfPricesToAdd != index) {
                index++;
                test.added = true;
                let quantity = test.quantity > 0 && totalPrice ? test.quantity : 1;
                totalPrices.price += price.totalPrice * quantity;
                totalPrices.originalPrice += price.originalPrice * quantity;
                if (amountOfPricesToAdd == index) {
                    break;
                }
            }
        }

        resetAdded(keys);

        return totalPrices;
    }

    const setSelectedVariant = (section, variant, articleNumber, quantity, packagingQuantity) => {

        if (section.maximumOfOneAllowed) {
            const hasSelectedVariant = quantity + packagingQuantity !== 0 && variant.articleNumber === articleNumber;
            return hasSelectedVariant;
        } else {
            if (variant.articleNumber === articleNumber) {
                if (quantity + packagingQuantity !== 0) {
                    return true
                }
                else {
                    return false;
                }
            } else {
                return variant.selected;
            }
        }
    }

    const setQuantity = (section, variant, articleNumber, quantity, packagingQuantity) => {
        if (section.maximumOfOneAllowed && variant.articleNumber !== articleNumber) {
            return 0
        } else {
            if (variant.articleNumber === articleNumber) {
                return quantity + packagingQuantity;
            } else {
                return variant.quantity;
            }
        }
    }

    const updateVariantQuantity = (articleNumber, packagingQuantity, quantity, sectionId, stopSelect) => {
        const selectedSection = data.sections.find(x => x.id === sectionId);
        selectedSection.userSelected = (quantity + packagingQuantity) > 0;
        const mandatorySectionsSelected = allMandatorySectionsSelected();
        const variants = selectedSection.variants.map(variant => {
            return {
                ...variant,
                quantity: setQuantity(selectedSection, variant, articleNumber, quantity, packagingQuantity, stopSelect),
                selected: setSelectedVariant(selectedSection, variant, articleNumber, quantity, packagingQuantity)
            }
        })
        console.log("variants", variants);
        selectedSection.variants = variants;

        let tempDataToUpdate = data;
        data.sections = data.sections.map(section => {
            return section.id === sectionId ? { ...selectedSection, variants: variants } : section});

        setdata(tempDataToUpdate);
        setsectionsSelected(mandatorySectionsSelected);        

        if (selectedSection.isMandatory) {
            dispatch(setSectionsSelected(mandatorySectionsSelected));            
        }

        let variant = variants.find(x => x.articleNumber == articleNumber);
        quantity = variant.quantity;
        if (!stopSelect) {
            select(variant, true, true, variant.quantity);
        }

        return variant;
    }

    const allMandatorySectionsSelected = () => {
        const mandatorySections = data.sections.filter(x => x.isMandatory);
        if (mandatorySections) {
            const hasStillMandatory = !mandatorySections.some(section => {
                return section.userSelected === false;
            });
            return hasStillMandatory;
        }
    }

    const getGrandTotal = () => {
        let totalPrices = getPriceFromKey(data.selectedCombinedKeys, 0, true);
        let totals = {
            grandTotal: totalPrices.price * quantity,
            originalTotal: totalPrices.originalPrice * quantity,
            configTotal: totalPrices.price
        }

        return totals;
    }

    const getStandardPriceTotal = () => {
        var total = 0;
        data.sections.forEach(s => s.variants.forEach((v) => {
            if (v.selected) {
                data.selectedCombinedKeys.filter(keys => {
                    if (v.key == keys.key) {
                        total += v.price * keys.quantity;
                    }
                });
            }
        }));

        return total;
    }

    const getPriceChange = (variant, price, section, oldPrice = false) => {        
        let value = [variant.key];
        let configprice;

        if (getConfigKeys()) {
            getConfigKeys().forEach(configKey => {
                value.push(configKey);
            });
        }

        let tempSelectedVariant = null,
            currentKey = [{ key: variant.key, value: value, added: false, quantity: variant.quantity }];

        var currentKeyIndex = data.selectedCombinedKeys.findIndex(x => x.key == variant.key)
        if (currentKeyIndex != -1) {
            currentKey[0].value = data.selectedCombinedKeys[currentKeyIndex].value;
        }

        if (section.maximumOfOneAllowed && section.userSelected && currentKeyIndex == -1) {
            section.variants.forEach((v) => {
                if (v.selected && v.key != variant.key) {
                    tempSelectedVariant = v;
                }
            });

            if (tempSelectedVariant != null) {
                var tempSelectedKey = [{ key: tempSelectedVariant.key, value: [tempSelectedVariant.key], added: false, quantity: 0 }];

                var tempSelectedKeyIndex = data.selectedCombinedKeys.findIndex(x => x.key == tempSelectedVariant.key);
                if (tempSelectedKeyIndex != -1) {
                    tempSelectedKey[0].value = data.selectedCombinedKeys[tempSelectedKeyIndex].value;
                }
                if (oldPrice) {
                    configprice = (getPriceFromKey(currentKey, price, false).originalPrice - getPriceFromKey(tempSelectedKey, tempSelectedVariant.price, false).originalPrice);
                    variant.SuperBuilderCampaignPrice = configprice;
                    return variant.SuperBuilderCampaignPrice
                }
                else {
                    configprice = (getPriceFromKey(currentKey, price, false).price - getPriceFromKey(tempSelectedKey, tempSelectedVariant.price, false).price);
                    variant.SuperBuilderPrice = configprice;
                    return variant.SuperBuilderPrice;
                }
            }
        }
        configprice = getPriceFromKey(currentKey, price, false);
        if (oldPrice) {
            variant.SuperBuilderCampaignPrice = configprice.originalPrice;
            return variant.SuperBuilderCampaignPrice
        }
        else {
            variant.SuperBuilderPrice = configprice.price;
            return variant.SuperBuilderPrice;
        }
    }

    const getConfigKeys = () => {
        var configKeys = data.selectedCombinedKeys.length > 0 ? data.selectedCombinedKeys[0].value.length > 1 ? data.selectedCombinedKeys[0].value.filter(v => {
            if (v != data.selectedCombinedKeys[0].key) {
                return v
            }
        }) : null : null;

        return configKeys;
    }

    const resetAdded = (selectedKeys) => {
        selectedKeys.forEach((key) => key.added = false);
    }

    const getSectionFromVariants = (variant) => {
        let section = null;

        data.sections.forEach(s => s.variants.forEach((v) => {
            if (v.articleNumber === variant.articleNumber) {
                section = s;
            }
        }));

        return section;
    }

    const setQuantityToGetSelectedQuantityTo0Or1 = (addOneOrRemoveAll, variant, section) => {
        let quantity = 0;
        if (addOneOrRemoveAll) {
            if (section.maximumOfOneAllowed) {
                if (variant.selected) {
                    quantity = variant.packagingQuantity > 0 ? 0 : 1;
                }
            }
            else {
                if (variant.selected) {
                    quantity = variant.packagingQuantity > 0 ? 0 : 1;
                }
            }

            if (!variant.selected) {
                quantity = variant.packagingQuantity * -1;
            }
        }

        return quantity;
    }

    const select = (variant, isChecked, dontUpdate, quantity) => {
        let addOneOrRemoveAll = quantity === undefined,
            section = getSectionFromVariants(variant);
        variant.selected = dontUpdate ? variant.selected : !variant.selected;

        quantity = setQuantityToGetSelectedQuantityTo0Or1(addOneOrRemoveAll, variant, section);

        if (!dontUpdate) {
            variant = updateVariantQuantity(variant.articleNumber, variant.packagingQuantity, quantity, section.id, true);
        }

        var currentState = data;
        section.variants.forEach((v) => {
            if (section.maximumOfOneAllowed && variant.key != v.key) {
                let index = currentState.selectedCombinedKeys.findIndex(x => x.key === v.key);
                if (index != -1) {
                    currentState.selectedCombinedKeys.splice(index, 1);
                }
            }
        });

        let keyIndex = currentState.selectedCombinedKeys.findIndex(x => x.key === variant.key);
        if (currentState.selectedCombinedKeys && keyIndex > -1 && variant.quantity === 0) {
            currentState.selectedCombinedKeys.splice([keyIndex], 1);
        }
        else if (currentState.selectedCombinedKeys && variant.quantity > 0 && keyIndex > -1) {
            currentState.selectedCombinedKeys[keyIndex].quantity = variant.quantity;
        }
        else {
            let variantKeys = [];
            if (currentState.selectedCombinedKeys.length > 0) {
                for (var u = 0; u < currentState.selectedCombinedKeys[0].value.length; u++) {
                    variantKeys.push(currentState.selectedCombinedKeys[0].value[u]);
                }
                variantKeys[0] = variant.key;
            }
            else {
                variantKeys.push(variant.key);
            }

            currentState.selectedCombinedKeys.push({ key: variant.key, value: variantKeys, added: false, quantity: variant.quantity, isMandatory: section.isMandatory, isMaximumOfOneAllowed: section.maximumOfOneAllowed });
        }
        
        openTheNextSection(variant.selected, section, currentState.sections);
                
        setdata(currentState);        

        dispatch(selectSuperBuilderVariant(currentState.selectedCombinedKeys))        
        props.updatePrice(currentState.selectedCombinedKeys, false, firstIteration, getNonSelectedMandatorySectionId(data.sections));
        setfirstIteration(false);

        refreshSelection();
    }

    const openTheNextSection = (select, section, sections) => {        
        let amountOfSections = sections.length > 0 ? sections.length - 1 : 0;
        let currentSectionIndex = sections.findIndex(x => x.id === section.id);
        if (amountOfSections > currentSectionIndex) {            
            sections[currentSectionIndex + 1].expanded = true;                   
        }
        
    }

    const getNonSelectedMandatorySectionId = (sections) => {
        const mandatorySections = sections.filter(x => x.isMandatory);
        if (mandatorySections) {
            const mandatorySectionWithNoSelection = mandatorySections.find(section => section.userSelected === false);
            return mandatorySectionWithNoSelection ? mandatorySectionWithNoSelection.id : "";
        }
    }

    const refreshPrice = (dataInput, quantity) => {
        let totalPrices = {
            price: 0,
            originalPrice: 0,
            grandTotal: 0
        };

        if (dataInput && dataInput == 0 || !props.isConfiguratorActive) {
            totalPrices.price = getStandardPriceTotal();
        }
        else {
            totalPrices = getTotalPriceFromKeys(dataInput.selectedCombinedKeys, true);
        }


        let totals = {
            grandTotal: totalPrices.price * quantity,
            originalTotal: totalPrices.originalPrice * quantity,
            configTotal: totalPrices.price
        }

        setgrandTotal(totals.grandTotal);
        setoriginalTotal(totals.originalTotal);
        setsuperBuilderTotal(totals.configTotal);
    }

    const getPriceFromKey = (keys, standardPrice, totalPrice) => {
        let prices = {
            price: 0,
            originalPrice: 0,
            grandTotal: 0
        };

        if (keys && keys == 0 || !props.isConfiguratorActive) {
            prices.price = standardPrice;
            prices.originalPrice = standardPrice;
            return prices;
        }

        prices = getTotalPriceFromKeys(keys, totalPrice);

        return prices;
    }

    const refreshSelection = () => {
        let totals = getGrandTotal();
        setgrandTotal(totals.grandTotal);
        setoriginalTotal(totals.originalTotal);
        setconfiguratorTotal(totals.configTotal);
        settotalsData(totals);                
        setselectedVariants(getSelectedVariants());        

        setTimeout(
            function () {
                refreshKlarnaWidget();
            }
                .bind(this),
            100
        );
    }

    const getSelectedVariants = () => {
        let selectedVariants = data.sections;
        let selectedVariantsName = selectedVariants.flatMap(x => x.variants.filter(v => v.selected)).map(x => getSelectedVariantName(x));
        return selectedVariantsName;
    }

    const getSelectedVariantName = (variant) => {
        if (variant) {
            if (variant.additionalInfo && variant.additionalInfo.row2) {
                return `${variant.name} -  ${variant.additionalInfo.row2}`;
            }
            else {
                return variant.name;
            }
        }
    }

    const toggleSections = (id) => {
        let tempDataToUpdate = data;
        data.sections = data.sections.map(el => { return el.id === id ? { ...el, expanded: !el.expanded } : el });
        setdata(tempDataToUpdate);   
        setrefreshSections(!refreshSections);
    }

    const refreshKlarnaWidget = () => {
        // Refresh Klarna widget
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }

    const GetFilterItem = (variant, section, variantIndex) => {        
        return (
            <li key={variant.key + variantIndex} className={`configurator-variants__item`}>
                {variant.imageData != null &&
                    <picture className="image-container contain">
                        <img className="configurator-variants__img-container" alt={variant.imageData.alt} itemProp="image" src={variant.imageData.thumbnail} />
                    </picture>
                }
                <div className="configurator-variants__name-container">
                    <Checkbox isChecked={variant.selected} onClick={select} isSmall={true} value={variant} ></Checkbox>
                    <div className="configurator-variants__info">
                        <a className="configurator-variants__name">{variant.name}</a>
                        <div className="configurator-variants__measurement">{variant.superBuilderVariantMeasurement}</div>
                        <div className="configurator-variants__price-container configurator-variants__superbuilder-variant">
                            {variant.campaignPrice != null && variant.campaignPrice != "" && variant.campaignPrice < variant.price ?
                                (
                                    <div className="configurator-variants__price-div">
                                        <div className="configurator-variants__original-price">
                                            <ConfiguratorOptionPrice price={getPriceChange(variant, variant.price, section, true)} formatter={formatter}></ConfiguratorOptionPrice>
                                        </div>
                                        <div className="configurator-variants__price">
                                            <ConfiguratorOptionPrice price={getPriceChange(variant, variant.campaignPrice, section)} formatter={formatter}></ConfiguratorOptionPrice>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="configurator-variants__price">
                                        <ConfiguratorOptionPrice price={getPriceChange(variant, variant.price, section)} formatter={formatter}></ConfiguratorOptionPrice>
                                    </div>
                                )
                            }
                        </div>
                        <QuantitySelector isSmall={true} quantity={variant.quantity} singleQuantity={section.maximumOfOneAllowed} 
                        articleNumber={variant.articleNumber} packagingQuantity={variant.packagingQuantity} sectionId={section.id} 
                        onChange={updateVariantQuantity}></QuantitySelector>
                    </div>
                </div>
            </li>
        )
    }

        return (
            <div className="superBuilder" key={refreshSections}>
                {data.sections && data.sections.length > 0 &&
                    <ul className="product-selector">
                        {data.sections.map((section, sectionIndex) =>
                            <li id={section.id} key={section.id} className={`product-selector__section 
                            ${section.expanded ? 'product-selector__section--active' : ''}`}>
                                <a className="product-selector__header" onClick={() => toggleSections(section.id)}>
                                    {section.userSelected ?
                                        <div className={'section-status section-status--done'}>
                                            <svg>
                                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#checked"></use>
                                            </svg>
                                        </div>
                                        :
                                        <div className={'section-status'}>
                                            <svg>
                                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#superbuilder"></use>
                                            </svg>
                                        </div>
                                    }
                                    <div className={` ${section.isMandatory ? 'product-selector__name-required' : 'product-selector__name'}`}>
                                        <span>
                                            <div className={`product-selector__name-text ${section.isMandatory ? 'required-big' : ''}`}>{section.superBuilderSectionHeader}</div>
                                        </span>
                                        <svg className="arrow">
                                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-down"></use>
                                        </svg>
                                    </div>
                                </a>
                                <div className={`product-selector__content`}>
                                    <ul className="configurator-variants">
                                        {section.variants.map((variant, variantIndex) => (GetFilterItem(variant, section, variantIndex)))}
                                    </ul>
                                </div>

                            </li>
                        )}
                        {anySelectionMade &&
                            <li key='yourselections' className={`product-selector__section product-selector__your-selections ${yourSelectionActive ? 'product-selector__section--active' : ''}`}>
                                <a className="product-selector__header" onClick={() => setyourSelectionActive(!yourSelectionActive)}>
                                    <div className="product-selector__name summary">
                                        <span>
                                            <div className={`product-selector__name-text`}>{translate('yourselection.header')}</div>
                                        </span>
                                        <svg className="arrow">
                                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-down"></use>
                                        </svg>
                                    </div>
                                </a>
                                <div className={`product-selector__content`}>
                                    <YourSelections sections={data.sections}></YourSelections>
                                </div>
                            </li>
                        }
                    </ul>
                }
            </div>);    
}

export default SuperBuilder;
